import React, { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { RegulationContext } from "../../../App";
import Utils from "../../../core/utilities/Utils";
import CarbonEmissionCalculator from "./CarbonEmissionCalculator";
import CarbonEmissionFilter from "./CarbonEmissionFilter";
import CarbonEmissionHeaderActions from "./CarbonEmissionHeaderActions";
import CarbonEmissionTable from "./CarbonEmissionTable";

const CarbonEmissionDataContainer = ({ t }) => {
	const { glbRegulation } = useContext(RegulationContext);
	const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
	const year = new Date().getFullYear();
	const [filterDisplay, setFilterDisplay] = useState(false)
	const [filter, setFilter] = useState({
		reportingPeriod: `${year}-${month}-01`,
		entity: '',
	});
	const [activeView, setActiveView] = useState('CALCULATOR');
	const [viewToggled, setViewToggled] = useState({ on: 0, to: '' });

	return (
		<div id='carbonEmissionContainer'>
			<div className="List_header">
				<h5 className="MH">{t("CarbonEmission.label")}</h5>
				<div className="Head_subMenuBox">
					<div className="me-2">
						<Form.Check
							className="toggle-switch"
							inline
							label={t("Calculator.label")}
							name="assessType"
							type="radio"
							id="inline-radio-2"
							value={'CALCULATOR'}
							checked={activeView === 'CALCULATOR' ? "checked" : ''}
							onChange={() => {
								setViewToggled({ on: Date.now(), to: 'CALCULATOR' });
							}}
						/>
						<Form.Check
							className="toggle-switch"
							inline
							label={t("Table.label")}
							name="assessType"
							type="radio"
							id="inline-radio-1"
							value={'TABLE'}
							checked={activeView === 'TABLE' ? "checked" : ''}
							onChange={() => {
								setViewToggled({ on: Date.now(), to: 'TABLE' });
							}}
						/>
					</div>
					<CarbonEmissionHeaderActions onFilterClick={() => setFilterDisplay(!filterDisplay)} />
				</div>
			</div>
			<div className={filterDisplay ? '' : 'd-none'}> 
				<CarbonEmissionFilter forCalculator={activeView === 'CALCULATOR'}
					onApplyFilter={(f) => setFilter(f)} onFilterHide={(value)=>setFilterDisplay(value)}/>
			</div>
			<div id='carbonEmissionDataHolder'>
				{
					activeView === 'CALCULATOR'
						?
						<CarbonEmissionCalculator key="calculator"
							filter={filter}
							viewToggled={viewToggled}
							confirmViewChange={(confirm) => {
								if (!confirm) return;

								setActiveView(viewToggled.to);
								setViewToggled({ on: 0, to: '' });
							}} />
						:
						<CarbonEmissionTable key="table"
							filter={filter}
							viewToggled={viewToggled}
							confirmViewChange={(confirm) => {
								if (!confirm) return;

								setActiveView(viewToggled.to);
								setViewToggled({ on: 0, to: '' });
							}} />
				}
			</div>
		</div>
	);
};

export default withTranslation()(CarbonEmissionDataContainer);
